export default __webpack_public_path__ + "assets/move-2.b00fc779.png";